import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SidebarDropdownProps } from './SidebarDropdown.types';

/**
 * Presentational drop-up dropdown shell used in the sidebar for both the user menu
 * and the faction selector. Renders the shared toggle (icon + truncated label) and a
 * full-width menu into which callers slot Dropdown.Header / Dropdown.Item / Dropdown.Divider.
 *
 * The default `outline-light` variant keeps the toggle legible against the dark
 * `bg-brand-surface` sidebar (the previous `outline-secondary` rendered dark-on-dark).
 *
 * @example
 * <SidebarDropdown icon={faUser} label={username} toggleId="user-dropdown">
 *   <Dropdown.Header>…</Dropdown.Header>
 *   <Dropdown.Divider />
 *   <Dropdown.Item onClick={logout}>Sign Out</Dropdown.Item>
 * </SidebarDropdown>
 */
export default function SidebarDropdown({
    icon,
    label,
    toggleId,
    children,
    variant = 'outline-light',
    drop = 'up',
    maxLabelWidth = 120,
    testId,
}: SidebarDropdownProps): React.ReactElement {
    return (
        <Dropdown drop={drop} data-testid={testId}>
            <Dropdown.Toggle
                variant={variant}
                id={toggleId}
                className="w-100 d-flex align-items-center justify-content-between"
            >
                <span className="d-flex align-items-center">
                    <FontAwesomeIcon icon={icon} className="me-2" />
                    <span className="text-truncate" style={{ maxWidth: `${maxLabelWidth}px` }}>
                        {label}
                    </span>
                </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="w-100">
                {children}
            </Dropdown.Menu>
        </Dropdown>
    );
}
